export default __webpack_public_path__ + "static/am-news-13f55a45ce371c1ab17fac93c2777583.jpg";